export default __webpack_public_path__ + "static/media/may2024-3.5dc1dbfc.jpg";